module.exports = "<source src=\"<%=src%>\" type=\"<%=type%>\">\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/playbacks/html5_video/public/index.html
 ** module id = 138
 ** module chunks = 0
 **/